import { axiosInstance } from "@/helper/axios-instance";
import type { Stock, DataAwareResponse } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useStockUpdate() {
  return useMutationWithValidation({
    mutationFn: async (data: Partial<Stock>) => {
      const response = await axiosInstance({
        method: "POST",
        url:  `Stock/Update`,
        data: data,
      });

      return response.data as DataAwareResponse<Stock>;
    },
    retry: 2,
    customMessage: {
      success: "Stock updated successfully",
    },
  });
}
